module.exports = __webpack_public_path__ + "img/card_tpo_img.4b105e25.png";